/**
 * SalesLayout Component
 * Navigation wrapper for the Sales module
 * Extracted from App.js for better maintainability
 */
import React from "react";

const SalesLayout = ({ activeTab, onNavigate, onBackToGears, children, currentUser }) => {
  const enabledTools = currentUser?.company?.tools_enabled?.sales;
  const isToolEnabled = (toolId) => !enabledTools || enabledTools.includes(toolId);

  const allNavItems = [
    { key: 'estimates', label: 'Estimates', icon: '📄', testId: 'sales-nav-estimates' },
    { key: 'invoices', label: 'Invoices', icon: '🧾', testId: 'sales-nav-invoices' },
    { key: 'clients', label: 'Clients', icon: '👥', testId: 'sales-nav-clients' },
    { key: 'crm', label: 'CRM', icon: '📇', testId: 'sales-nav-crm' },
    { key: 'notifications', label: 'Notifications', icon: '🔔', testId: 'sales-nav-notifications' },
    { key: 'reports', label: 'Reports', icon: '📊', testId: 'sales-nav-reports' },
    { key: 'settings', label: 'Settings', icon: '⚙️', testId: 'sales-nav-settings' }
  ];
  const navItems = allNavItems.filter(item => isToolEnabled(item.key));

  return (
    <div className="min-h-screen bg-gray-100 overflow-x-hidden">
      <div className="hidden lg:flex min-h-screen">
        <aside className="w-64 bg-white border-r border-gray-200 px-4 py-6 flex flex-col lg:sticky lg:top-0 lg:h-screen lg:overflow-y-auto">
          <div className="text-lg font-bold text-gray-800 mb-4">Sales</div>
          <button
            onClick={onBackToGears}
            className="mb-4 flex items-center gap-2 text-sm font-semibold text-gray-600 hover:text-gray-900"
            data-testid="sales-back-to-gears-button"
          >
            ← Back to Gears
          </button>
          <nav className="space-y-2 flex-1">
            {navItems.map((item) => (
              <button
                key={item.key}
                onClick={() => onNavigate(item.key)}
                className={`w-full flex items-center gap-3 px-4 py-2 rounded-lg text-sm font-semibold transition ${
                  activeTab === item.key
                    ? 'bg-gray-900 text-white'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
                data-testid={item.testId}
              >
                <span className="text-base" aria-hidden="true">{item.icon}</span>
                <span>{item.label}</span>
              </button>
            ))}
          </nav>
        </aside>
        <main className="flex-1 p-6 overflow-x-hidden">{children}</main>
      </div>
      <div className="lg:hidden flex flex-col min-h-screen overflow-x-hidden">
        <main className="flex-1 p-4 pb-36 overflow-x-hidden max-w-[100vw]">
          <button
            onClick={onBackToGears}
            className="mb-4 flex items-center gap-2 text-sm font-semibold text-gray-600 hover:text-gray-900"
            data-testid="sales-back-to-gears-mobile"
          >
            ← Back to Gears
          </button>
          {children}
        </main>
        <nav
          className="fixed left-3 right-3 bg-white border border-gray-200 shadow-lg rounded-2xl"
          style={{ bottom: '5.5rem' }}
          data-testid="sales-mobile-nav"
        >
          <div className="flex justify-between gap-2 py-2 px-3 pr-16" style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}>
            {navItems.map((item) => (
              <button
                key={item.key}
                onClick={() => onNavigate(item.key)}
                className={`flex flex-col items-center text-xs font-semibold ${
                  activeTab === item.key ? 'text-gray-900' : 'text-gray-500'
                }`}
                data-testid={`${item.testId}-mobile`}
                aria-label={item.label}
              >
                <span className="text-lg" aria-hidden="true">{item.icon}</span>
                <span className="text-[10px] leading-tight hidden sm:block">{item.label}</span>
              </button>
            ))}
          </div>
        </nav>
      </div>
    </div>
  );
};

export default SalesLayout;
